import { connect } from 'react-redux';

import LocalResource from '../../components/sider/localResource';

export default connect()(LocalResource);



// WEBPACK FOOTER //
// ./containers/sider/localResource.js